import { Warning } from '@react-apps/design-system';

/**
 * Aviso de questão anulada, no topo do body. Era uma linha de texto colorido,
 * fácil de passar batido justo na informação que muda a leitura da questão.
 *
 * O DS não tem Alert: é Tailwind inline, como o aviso da TOTVS, com os pares
 * `warning` de `styles/tokens.ts` (são os valores do `amber`). Sem
 * `role="status"`: o aviso existe ao montar, e `status` só anuncia mudança. O
 * ícone é decorativo; o texto carrega o significado.
 */
export function AnnulledNotice() {
  return (
    <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm font-medium text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-300">
      <Warning size="sm" className="mt-0.5 shrink-0" />
      <p>Questão anulada — não há alternativa correta a considerar.</p>
    </div>
  );
}
